import { currencyDecimalSeparator } from '../../utils/constants';
import { numberFormatterWithMinimumFractionDigits } from './numberFormatter';
export const currencyFormatter = (value, currency) => value || value === 0
    ? `${numberFormatterWithMinimumFractionDigits(value)} ${currency || ''}`
    : undefined;
export const currencyPayload = (value) => {
    if (typeof value === 'undefined' || value === null)
        return undefined;
    //remove spaces and replace currencyDecimalSeparator with dot
    return String(value)
        .replace(/\s/g, '')
        .replace(currencyDecimalSeparator, '.');
};
